<script>
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import SearchPayload from '@utils/searchPayload'
import DateTimeFormatRangerOnTable from '@components/molecules/date-time-format-ranger-on-table.vue'
import PopupFilter from '@views/Notification/list/popup-filter.vue'
import { addParamsToLocation } from '@utils/helpers'
import tableFields from './tableFields'

export default {
  page: {
    title: 'Notification',
    meta: [{ name: 'description', content: 'The Notification page.' }],
  },
  components: {
    PopupFilter,
    DateTimeFormatRangerOnTable,
  },
  data() {
    return {
      searchBody: new SearchPayload.Builder().withAgentId().withStatus(),
      fields: tableFields,
      filtered: false,
    }
  },
  computed: {
    ...notificationComputed,
    notificationList() {
      return this.getNotificationList
    },
    paginationComputed() {
      return this.getNotificationPaginate
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (filter[key] === 'undefined') {
        filter[key] = ''
      }
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.fetchingNotificationList(this.searchBody)
  },
  methods: {
    ...notificationMethods,
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchNotification()
    },
    handleSearchNotification() {
      this.fetchingNotificationList(this.searchBody)
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchNotification()
      this.filtered = !reset
    },
    handleSorter(key) {
      if (!~key.indexOf('notification_id')) {
        this.searchBody = { ...this.searchBody, order_by: key }
      } else {
        const id = key[key.length - 1] === '-' ? 'id-' : 'id'
        this.searchBody = { ...this.searchBody, order_by: id }
      }
      this.handleSearchNotification()
    },
  },
}
</script>

<template>
  <div>
    <div>
      <CButtonGroup>
        <CButton
          color="dark"
          variant="outline"
          @click="$router.push({ name: 'notificationRegistration' })"
        >
          新規登録
        </CButton>
        <PopupFilter @submit:search="handleFilter" />
      </CButtonGroup>
    </div>
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    />
    <BaseTable
      striped
      border
      :table-fields="fields"
      :data-tables="notificationList"
      @sorterBy="handleSorter"
    >
      <template v-slot:schedule_start="{ item }">
        <td class="py-2">
          <DateTimeFormatRangerOnTable
            :start="item.schedule_start"
            :end="item.schedule_end"
          />
        </td>
      </template>
      <template v-slot:start="{ item }">
        <td class="py-2">
          <DateTimeFormatRangerOnTable :start="item.start" :end="item.end" />
        </td>
      </template>
      <template v-slot:title="{ item }">
        <td>
          <CLink
            class="feelline-limit-line"
            :to="`/panel/notification/${item.notification_id}`"
            >{{ item.title }}</CLink
          >
        </td>
      </template>
      <template v-slot:link="{ item }">
        <td class="py-2">
          <CLink v-if="item.link !== '-'" :href="item.link" target="_blank">
            <font-awesome-icon size="lg" icon="globe" />
          </CLink>
          <span v-else>
            {{ item.link }}
          </span>
        </td>
      </template>
      <template v-slot:filter="{ item }">
        <td>
          <CIcon v-if="item.filter === 1" name="cil-user" />
          <CIcon v-else name="cil-people" />
        </td>
      </template>
    </BaseTable>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feelline-limit-line {
  display: -webkit-box;
  max-height: 1.2rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
